/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-17 09:30:36
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-06 13:53:55
 * @FilePath: \linglan-pc-front\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {  // 初始化状态值--一定要有该属性对象         
    // redirectUri: "https://pctes.linglan.com/mycourses",
    //  appid: "wxa1fa1045265f85dd",
    redirectUri: "https://pc.linglan.com/mycourses",
    appid: "wx8df0574760dd9e64",
    scope: "snsapi_login",
    userInfo:JSON.parse(localStorage.getItem("userInfo"))?JSON.parse(localStorage.getItem("userInfo")):{
        face:'',
        alias:''
    },
    loading:null
}
const mutations = {  // 自定义改变state初始值的方法--一定要有该属性对象
    STORE_USERINFO(state, params) {
        state.userInfo= params;
    },
    STORE_LOADING(state, params) {
        state.loading= params;
    }
}
const getters = {  // 状态计算属性--该属性对象不是必须的            

}
const actions = { // 异步操作状态--该属性对象不是必须的

}
const modules = {  // 状态模块--该属性对象不是必须的

}

const store = new Vuex.Store({
    state,
    mutations,
    //下面三个非必须
    getters,
    actions,
    modules
})

export default store